import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { AccessPage, AuthorizedPage, DeclinedPage } from '../../../pages';
import { PartialRouter } from '../../types';

export const AccessRouter = {
  '/_private-routes/access/': [AccessPage, { validateSearch: zodValidator(z.object({ code: z.string().optional() })) }],
  '/_private-routes/access/authorized': [AuthorizedPage, {}],
  '/_private-routes/access/declined': [DeclinedPage, {}]
} as const satisfies PartialRouter;
